// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__Q-Le7","lds-spinner":"Loader_lds-spinner__1GugJ"};